<div class="modal-inner">
    <div class="modal-inner-inner">
        <h1>Wijzig projectnummer</h1>
        <input [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
        <div class="results">
            @if (searching) {
                <div class="result text-center">aan het zoeken...</div>
            }
            @if (!searching && projects?.length === 0) {
                <div class="result text-center">
                    {{ fcProjectSearch.value?.length > 0 ? 'project niet gevonden' : 'voer een projectnummer in' }}
                </div>
            }
            @for (project of projects; track project) {
                <div
                    class="result"
                    [class.active]="project.afas_project_id === data.currentProjectId"
                    (click)="selectProject(project)">
                    <strong>{{ project.afas_project_id }}</strong> {{ project.location }}
                    @if (project.afas_project_id === data.currentProjectId) {
                        (huidig)
                    }
                </div>
            }
        </div>
    </div>

    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
